import React from "react";
import { AiOutlineLogout, AiOutlineCloseCircle } from "react-icons/ai";
import { Container, Row, Col, Dropdown } from "react-bootstrap";
import { MdKeyboardBackspace } from "react-icons/md";
import Swal from "sweetalert2";
import { GetToken } from "../getToken";
import axios from "axios";
import { Link, NavLink, useLocation } from "react-router-dom";
import { DateFormat, SurveyStartDate, SurveyEndDate, SurveyNote, companyLogoSrc } from "../../common/DateFormat";

import Cookies from "js-cookie";

import logo from "../../../assets/img/logo.png";

const Header = ({ userSurveys, surveyDetails, BASE_URL, CookieURL }) => {
  /* get REACT_APP_API_URL from .env file */
  const { REACT_APP_BASE_URL, REACT_APP_API_URL, REACT_APP_WEBSITE_URL, REACT_APP_IMAGE_URL, REACT_APP_CookieURL } =
    process.env;

  const logout = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `logout`,
      cancelButtonText: `cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        var token = GetToken();
        axios
          .get(`${REACT_APP_API_URL}/logout`, {
            headers: {
              Authorization: token,
            },
          })
          .then((result) => {
            if (result.status === 200) {
              sessionStorage.clear();
              Cookies.remove("AuthToken", { domain: `${REACT_APP_CookieURL}` });
              window.location = REACT_APP_BASE_URL + "/login";
            }
          })
          .catch((err) => {
            sessionStorage.clear();
            // localStorage.clear();
            // sessionStorage.clear();
            Error(404, "Something went wrong.");
            window.location = REACT_APP_BASE_URL + "/login";
          });
      }
    });
  };

  const closeTab = () => {
    Swal.fire({
      title: "Are you sure you want to Close?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `close`,
      cancelButtonText: `cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        var token = sessionStorage.getItem("analytics_token");
        if (token) {
          sessionStorage.removeItem("analytics_token");
          window.location = REACT_APP_BASE_URL + "/login";
        }
        window.opener = null;
        window.open("", "_self");
        window.close();
      }
    });
  };

  return (
    <>
    <div className="sticky_header">
      <div className="header bg-white border-bottom">
        <Container fluid>
          <div className="header-inner d-flex justify-content-between">
            <div className="header-logo">
              <Link to={{ pathname: `${REACT_APP_WEBSITE_URL}` }} target={"_blank"}>
                <img src={logo} alt="logo" className="nav-logo" />
              </Link>
            </div>
            <div className="header-right d-flex">
              {surveyDetails.companyLogoURL === null ||
              surveyDetails.companyLogoURL === undefined ||
              surveyDetails.companyLogoURL == "" ? (
                <></>
              ) : (
                <div className="header-logo">
                  <img src={companyLogoSrc(surveyDetails.companyLogoURL)} alt="logo" className="nav-logo"></img>
                </div>
              )}
              {/* <div className="orgname d-flex align-items-center justify-content-start">{surveyDetails.CompanyName}</div> */}
              <div className="d-flex align-items-center justify-content-end">
                {/* }
                <div className="back" onClick={() => window.open(BASE_URL + "/SurveyList", "_self")}>
                  <MdKeyboardBackspace /> Back
                </div> { */}

                <div className="logout" onClick={() => logout()}>
                  <AiOutlineLogout />
                  &nbsp; Logout
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
      <div class="bg-white border-bottom">
        <Container fluid>
          <div className="row h-bottom">
            <div className="col-xl-8 col-lg-8 col-lg-4 col-md-12 col-sm-12 col-12">
              <div className="surveyselected">
                <div className="surveyname" dangerouslySetInnerHTML={{ __html: surveyDetails.SurveyName }}></div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-12">
              <div className="survey-status-update">
                <div className="SurveyNote text-danger me-3">
                  <SurveyNote end_date={surveyDetails.ExpiryDate} />
                </div>
                {userSurveys.length > 1 && (
                  <Dropdown>
                    <Dropdown.Toggle
                      variant="success"
                      id="dropdown-basic"
                      className="survey-switch-dropdown k-button k-primary rounded-0 btn-grad btn-grad-blue border-0">
                      Change Survey
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {userSurveys.map((survey, index) => (
                        <Dropdown.Item
                          href="#"
                          key={index}
                          onClick={() => (window.location = `${survey.SurveyId}`)}
                          dangerouslySetInnerHTML={{ __html: survey.SurveyName }}></Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          </div>
          {/* <div className="survey-status-update">
            <div className={`surveyStatus ${surveyDetails.SurveyStatus === "Closed" ? "closed" : "active"}`}>
              <span></span>
              {surveyDetails.SurveyStatus == "Open" ? "Active" : "Closed"}
            </div>
            <div className="SurveyNote">
              <SurveyNote end_date={surveyDetails.ExpiryDate} />
            </div>
          </div> */}
        </Container>
      </div>
    </div>
    </>
  );
};

export default Header;
